export default () => {
  return Object.fromEntries([...new URLSearchParams(window.location.search)])
}
